import { type Router } from 'vue-router'
import { createGtm, type VueGtmUseOptions } from '@gtm-support/vue-gtm'

const getGtmOptions = (router: Router): VueGtmUseOptions => {
  return {
    id: APP_ENV.VITE_APP_GTM_ID,
    defer: false,
    enabled: true,
    debug: false,
    loadScript: true,
    vueRouter: router,
    trackOnNextTick: false
  }
}

export const getGtm = (router: Router) => {
  const options = getGtmOptions(router)
  return createGtm(options)
}
